import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { DbContextService } from '../../../services/db-context.service';
import { Helper } from '../../common/helper';
import { ShipBeginEndStockHeader } from '../model/shipBeginEndStockHeader';
import swal from 'sweetalert2';

@Injectable({
  providedIn: 'root'
})
export class StocksListService {

  constructor(private http: HttpClient, private dbxService: DbContextService) { }

  buildNewShipBeginEndStockHeaderData(departmentID: number, transDate: string, stockType: string) {

    let paramObject = {
      'departmentID': departmentID,
      'transDate': transDate,
      'stockType': stockType
    }

    return this.http.post(Helper.API_URL() + '/api/Budget/BuildNewShipBeginEndStockHeaderData', paramObject);
  }

  GetShipBeginEndStockData(ShipBeginEndStockHeaderID: any) {

    let parameter = `${ShipBeginEndStockHeaderID}`;

    return this.http.get(Helper.API_URL() + '/api/Budget/GetShipBeginEndStockData/' + parameter);
  }

  getOrderListHeaderList() {
    return this.http.post(Helper.API_URL() + '/api/Orders/GetOrderListHeaderList', {});
  }

  getOrderListHeaderID(departmentIDList: any, shipIDList: any, supplierIDList: any) {

    let paramObject = {
      'departmentIDList': departmentIDList,
      'shipIDList': shipIDList,
      'supplierIDList': supplierIDList
    }

    return this.http.post(Helper.API_URL() + '/api/Orders/GetOrderListHeaderID', paramObject);
  }

  GetOrderListDataWithGroup(orderListHeaderID: any) {

    let paramObject = {
      'orderListHeaderID': orderListHeaderID,
    }

    return this.http.post(Helper.API_URL() + '/api/Orders/GetOrderListDataWithGroup', paramObject);
  }

  BuildNewStockListWithGroup(deptID: number, stockType: string, stockDate: string, stockID: number) {

    let paramObject = {
      'deptID': deptID,
      'stockType': stockType,
      'stockDate': stockDate,
      'stockID': stockID
    }

    return this.http.post(Helper.API_URL() + '/api/Orders/BuildNewStockListWithGroup', paramObject);
  }

  GetOrderListDetailReceivedQuatity(departmentID: number, periodFrom: string, periodTo: string) {

    // convert to httpPost
    let paramObject = {
      'departmentID': departmentID,
      'periodFrom': periodFrom,
      'periodTo': periodTo,
    }

    return this.http.post(Helper.API_URL() + '/api/Orders/GetOrderListDetailReceivedQuatity', paramObject);
  }

  processCreateStockData(data: any) {
    return this.http.post(Helper.API_URL() + '/api/Budget/CreateShipBeginEndStockDataAndUpdateContract', data);
  }

  updateCreateStockData(data: any) {
    return this.http.post(Helper.API_URL() + '/api/Budget/UpdateShipBeginEndStockDataAndUpdateContract', data);
  }

  stockConversionAI(comment: string, ifs_weight: number) {
    let paramObject = {
      'comment': comment,
      'ifs_weight': ifs_weight
    }
    return this.http.post(Helper.API_URL() + '/api/Orders/StockConversionAI', paramObject);
  }

  saveShipBeginEndStockTempData(data: any) {
    return this.http.post(Helper.API_URL() + '/api/Budget/SaveShipBeginEndStockTempData', data);
  }


  //Indexed DB 
  getStockOrderListIndxdb(orderHeaderGUID: string): Promise<Object> {
    let promise = new Promise<Object>((resolve) => {

      this.dbxService.openDatabase().then(db => {
        const tx = db.transaction('OWS_tblStockOrderList', 'readwrite');
        tx.oncomplete = (ev) => {

        }
        tx.onerror = (err: any) => {
          console.warn(err);
        }
        let store = tx.objectStore('OWS_tblStockOrderList');
        store.get(orderHeaderGUID).then(
          (res: any) => {
            resolve(res);
          }
        )
        // return tx.done;// complete;
      });

    });
    return promise;
  }

  saveStockOrderList(stockOrderListGUID: string, orderList: any) {
    const obj = {
      stockOrderListID: stockOrderListGUID,
      orderList: orderList,

    };

    this.dbxService.openDatabase().then(db => {
      const tx = db.transaction('OWS_tblStockOrderList', 'readwrite');
      tx.oncomplete = (ev) => {

      }
      tx.onabort = (event: any) => {
        const err = event.target?.error;
        if (err?.name === 'QuotaExceededError') {
          this.handleQuotaExceeded();
        }
      };

      tx.onerror = (event: any) => {
        console.warn(event);
        const err = event.target?.error;
        if (err?.name === 'QuotaExceededError') {
          this.handleQuotaExceeded();
        }
      };

      let store = tx.objectStore('OWS_tblStockOrderList');

      try {
        let req = store.add(obj);
      } catch (e: any) {
        if (e?.name === 'QuotaExceededError') {
          this.handleQuotaExceeded();
        }
      }
    });
  }

  updateStockOrderList(stockOrderListGUID: string, orderList: any) {
    const obj = {
      stockOrderListID: stockOrderListGUID,
      orderList: orderList,

    };

    this.dbxService.openDatabase().then(db => {
      const tx = db.transaction('OWS_tblStockOrderList', 'readwrite');
      tx.oncomplete = (ev) => {

      }
      tx.onabort = (event: any) => {
        const err = event.target?.error;
        if (err?.name === 'QuotaExceededError') {
          this.handleQuotaExceeded();
        }
      };

      tx.onerror = (event: any) => {
        console.warn(event);
        const err = event.target?.error;
        if (err?.name === 'QuotaExceededError') {
          this.handleQuotaExceeded();
        }
      };
      let store = tx.objectStore('OWS_tblStockOrderList');
      try {
        let req = store.put(obj);
      } catch (e: any) {
        if (e?.name === 'QuotaExceededError') {
          this.handleQuotaExceeded();
        }
      }

      return tx.done;// complete;
    });
  }

  getStockDetailIndxdb(stockID: string): Promise<Object> {
    let promise = new Promise<Object>((resolve) => {

      this.dbxService.openDatabase().then(db => {
        const tx = db.transaction('OWS_tblStockDetailList', 'readwrite');
        tx.oncomplete = (ev) => {

        }
        tx.onerror = (err: any) => {
          console.warn(err);
        }
        let store = tx.objectStore('OWS_tblStockDetailList');
        store.get(stockID).then(
          (res: any) => {
            resolve(res);
          }
        )
        // return tx.done;// complete;
      });

    });
    return promise;
  }

  saveStockDetail(stockID: string, stockDetailList: any) {
    const obj = {
      stockDetailID: stockID,
      stockDetailList: stockDetailList,

    };

    this.dbxService.openDatabase().then(db => {
      const tx = db.transaction('OWS_tblStockDetailList', 'readwrite');
      tx.oncomplete = (ev) => {

      }
      tx.onabort = (event: any) => {
        const err = event.target?.error;
        if (err?.name === 'QuotaExceededError') {
          this.handleQuotaExceeded();
        }
      };

      tx.onerror = (event: any) => {
        console.warn(event);
        const err = event.target?.error;
        if (err?.name === 'QuotaExceededError') {
          this.handleQuotaExceeded();
        }
      };

      let store = tx.objectStore('OWS_tblStockDetailList');

      try {
        let req = store.add(obj);
      } catch (e: any) {
        if (e?.name === 'QuotaExceededError') {
          this.handleQuotaExceeded();
        }
      }
    });
  }

  updateStockDetail(stockID: string, stockDetailList: any) {
    const obj = {
      stockDetailID: stockID,
      stockDetailList: stockDetailList,

    };

    this.dbxService.openDatabase().then(db => {
      const tx = db.transaction('OWS_tblStockDetailList', 'readwrite');
      tx.oncomplete = (ev) => {

      }
      tx.onabort = (event: any) => {
        const err = event.target?.error;
        if (err?.name === 'QuotaExceededError') {
          this.handleQuotaExceeded();
        }
      };

      tx.onerror = (event: any) => {
        console.warn(event);
        const err = event.target?.error;
        if (err?.name === 'QuotaExceededError') {
          this.handleQuotaExceeded();
        }
      };

      let store = tx.objectStore('OWS_tblStockDetailList');
      try {
        let req = store.put(obj);
      } catch (e: any) {
        if (e?.name === 'QuotaExceededError') {
          this.handleQuotaExceeded();
        }
      }
      return tx.done;// complete;
    });
  }

  deleteStockIndexDb(shipBeginEndStockHeaderID: any): Promise<Object> {
    let promise = new Promise<Object>((resolve) => {
      //delete from order header
      this.dbxService.openDatabase().then(db => {
        let tx = db.transaction('OWS_tblStockInfoHeader', 'readwrite');
        let store = tx.objectStore('OWS_tblStockInfoHeader');
        store.delete(shipBeginEndStockHeaderID);
      });

      //delete from order detail
      this.dbxService.openDatabase().then(db => {
        let tx = db.transaction('OWS_tblStockDetailList', 'readwrite');
        let store = tx.objectStore('OWS_tblStockDetailList');
        store.delete(shipBeginEndStockHeaderID);
      });

      resolve(shipBeginEndStockHeaderID);
    });
    return promise;
  }

  getStockReceivedQtyIndxdb(stockID: string): Promise<Object> {
    let promise = new Promise<Object>((resolve) => {

      this.dbxService.openDatabase().then(db => {
        const tx = db.transaction('OWS_tblStockReceivedQuantity', 'readwrite');
        tx.oncomplete = (ev) => {

        }
        tx.onerror = (err: any) => {
          console.warn(err);
        }
        let store = tx.objectStore('OWS_tblStockReceivedQuantity');
        store.get(stockID).then(
          (res: any) => {
            resolve(res);
          }
        )
        // return tx.done;// complete;
      });

    });
    return promise;
  }

  saveStockReceivedQtyIndxdb(stockID: string, stockReceivvedQty: any) {
    const obj = {
      ID: stockID,
      stockReceivvedQtyList: stockReceivvedQty,

    };

    this.dbxService.openDatabase().then(db => {
      const tx = db.transaction('OWS_tblStockReceivedQuantity', 'readwrite');
      tx.oncomplete = (ev) => {

      }
      tx.onabort = (event: any) => {
        const err = event.target?.error;
        if (err?.name === 'QuotaExceededError') {
          this.handleQuotaExceeded();
        }
      };

      tx.onerror = (event: any) => {
        console.warn(event);
        const err = event.target?.error;
        if (err?.name === 'QuotaExceededError') {
          this.handleQuotaExceeded();
        }
      };

      let store = tx.objectStore('OWS_tblStockReceivedQuantity');
      try {
        let req = store.add(obj);
      } catch (e: any) {
        if (e?.name === 'QuotaExceededError') {
          this.handleQuotaExceeded();
        }
      }
    });
  }

  updateStockReceivedQtyIndxdb(stockID: string, stockReceivvedQty: any) {
    const obj = {
      ID: stockID,
      stockReceivvedQtyList: stockReceivvedQty,


    };

    this.dbxService.openDatabase().then(db => {
      const tx = db.transaction('OWS_tblStockReceivedQuantity', 'readwrite');
      tx.oncomplete = (ev) => {

      }
      tx.onabort = (event: any) => {
        const err = event.target?.error;
        if (err?.name === 'QuotaExceededError') {
          this.handleQuotaExceeded();
        }
      };

      tx.onerror = (event: any) => {
        console.warn(event);
        const err = event.target?.error;
        if (err?.name === 'QuotaExceededError') {
          this.handleQuotaExceeded();
        }
      };

      let store = tx.objectStore('OWS_tblStockReceivedQuantity');
      try {
        let req = store.put(obj);
      } catch (e: any) {
        if (e?.name === 'QuotaExceededError') {
          this.handleQuotaExceeded();
        }
      }
      return tx.done;// complete;
    });
  }

  updateStockOverviewSubmittedIndxDB(stockId: any, isUpdatedOffline: any): Promise<Object> {
    let promise = new Promise<Object>((resolve) => {
      this.dbxService.openDatabase().then(db => {
        let tx = db.transaction('OWS_tblStocksOverviewSubmitted', 'readwrite');
        let store = tx.objectStore('OWS_tblStocksOverviewSubmitted');
        tx.onabort = (event: any) => {
          const err = event.target?.error;
          if (err?.name === 'QuotaExceededError') {
            this.handleQuotaExceeded();
          }
        };

        tx.onerror = (event: any) => {
          console.warn(event);
          const err = event.target?.error;
          if (err?.name === 'QuotaExceededError') {
            this.handleQuotaExceeded();
          }
        };

        store.get(stockId).then(
          (stock: ShipBeginEndStockHeader) => {
            if (stock) {
              stock.isUpdatedOffline = isUpdatedOffline;
              try {
                store.put(stock);
              } catch (e: any) {
                if (e?.name === 'QuotaExceededError') {
                  this.handleQuotaExceeded();
                }
              }
            }
            resolve(stock);
          });
      });
    });
    return promise;
  }

  handleQuotaExceeded() {
    swal
      .fire({
        title: 'Error',
        html: '<span>IndexedDB storage qouta exceeded.</span>',
        icon: "error",
        confirmButtonText: "OK",
        allowOutsideClick: false,
        allowEscapeKey: false,
      })
      .then((result) => {
        if (result.value) {
        }
      });
  }
}
